import { Navigate, useLocation } from 'react-router-dom';
import { type ReactNode } from 'react';
import { useMeQuery } from '@/api/queries';
import { Spinner } from '@/components/ui/Spinner';

export function ProtectedRoute({ children }: { children: ReactNode }) {
  const location = useLocation();
  const { data, isLoading, isError } = useMeQuery();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spinner />
      </div>
    );
  }
  if (isError || !data) {
    return <Navigate to="/login" replace state={{ from: location.pathname }} />;
  }
  return <>{children}</>;
}
